<template>
  <div class="help-module">
    <!--
    <div class="hm-part1">
      可瀚学堂APP采用科大讯飞的语音识别和评测技术、游戏化激励、人工智能的分析评估技术，老师可在APP上一键布置作业，学生也在APP上完成作业。学生们可以在APP上观看动画、学习和复习故事对话，并完成逐句跟读、长段背诵、趣味配音等作业。大量节省家长陪学时间，减轻老师批阅压力，提高学生学习积极性。
    </div>
    -->
    <div class="hm-part2">
      <card></card>
      <ul class="hm-part2-step">
        <!--
        <li @click="skip('buy')"><p>如何购买课程？</p></li>
        <li @click="skip('active')"><p>如何激活课程？</p></li>
        <li @click="skip('class')"><p>如何加入班级？</p></li>
        <li @click="skip('assignment')"><p>如何完成作业？</p></li>
        <li @click="skip('study')"><p>家庭学习指导</p></li>
        -->
        <li @click="skip('evaluate')"><p>语音评测如何打分？</p></li>
        <li @click="skip('medal')"><p>如何获得可币和勋章？</p></li>
        <li @click="skip('list')"><p>其他问题？</p></li>
      </ul>
      <!--<div class="hm-button" @click="skip('option')">意见反馈</div>-->
    </div>
  </div>
</template>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss" rel="stylesheet/scss">
@import "../../../src/assets/css/basic";

.help-module {
  .hm-part1,
  .hm-part2 {
    padding-left: p2r(20);
    padding-right: p2r(20);
  }
  .hm-part1 {
    padding-top: p2r(20);
    padding-bottom: p2r(20);
    font-size: p2r(16);
    text-indent: p2r(32);
    color: white;
    background: url("img/blue-bg.png") center top no-repeat;
    background-size: 100% 100%;
  }
  .hm-part2 {
    padding-top: p2r(30);
    padding-bottom: p2r(50);
    // .hm-part2-contact {
    //   padding: p2r(39) p2r(30) p2r(26);
    //   font-size: p2r(16);
    //   line-height: p2r(38);
    //   background: url("img/white-bg.png") center top no-repeat;
    //   background-size: 100% 100%;
    //   a {
    //     color: $blue;
    //     text-decoration: underline;
    //   }
    // }
    .hm-part2-step {
      margin-top: p2r(5);
      li {
        display: block;
        height: p2r(51);
        line-height: p2r(51);
        padding-left: p2r(13);
        width: 100%;
        font-size: p2r(16);
        color: $white;
        background-image: linear-gradient(-15deg, #33e5ff 0%, #24bcff 100%),
          linear-gradient(#31caff, #31caff);
        border-radius: 10px;
        position: relative;
        &:first-child{
          margin-top: p2r(21);
        }
        &:not(:first-child){
          margin-top: p2r(9); 
        }
        &::after{
          content: '';
          position: absolute;
          right: p2r(10);
          top: p2r(19);
          width: p2r(8);
          height: p2r(14);
          background: url('./img/arrow.png')no-repeat center center;
          background-size: cover;
        }
      }
    }
    .hm-button {
      text-align: center;
      margin: 0 auto;
      width: p2r(160);
      height: p2r(50);
      line-height: p2r(50);
      font-size: p2r(15);
      color: white;
      background: url("img/button.png") center top no-repeat;
      background-size: 100% 100%;
    }
  }
}
</style>
<script>
import Card from "../../components/Card";
export default {
  name: "hello",
  data() {
    return {
      data: 1
    };
  },
  created() {
    document.title = "可瀚学堂FAQ";
  },
  methods: {
    skip(name) {
      this.$router.push({
        name: name
      });
    }
  },
  components: {
    Card
  }
};
</script>
